import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import {
    Layout, Breadcrumb, Row, Col, Form, Input, Select, Upload, message, Button, Tabs, InputNumber, Modal, Spin, Radio
} from 'antd';
import { HomeOutlined, UploadOutlined, SaveOutlined } from '@ant-design/icons';
import ImgCrop from 'antd-img-crop';
import JoditEditor from "jodit-react";
import { getAccessToken } from 'axios-jwt';
import CONSTANT from '../../../config/constant';
import { axiosInstance } from '../../../config/api';
import * as COMMON from '../../../config/common';
const status = [
    { value: 'false', label: 'Chờ kiểm duyệt' },
    { value: 'true', label: 'Đã kiểm duyệt' },
];
const userstatus = [
    { value: 'publish', label: 'Công khai' },
    { value: 'draft', label: 'Bản nháp' },
];
const configEditor = {
    height: 300,
    language: 'vi',
    i18n: {
        vi: {
            'Type something': 'Nhập nội dung...',
            'Paste as HTML': 'Dán dưới dạng HTML',
            'Your code is similar to HTML. Keep as HTML?': 'Mã của bạn tương tự như HTML. Giữ dưới dạng HTML?',
            'Keep': 'Giữ',
            'Insert as Text': 'Chèn dưới dạng văn bản',
            'Insert only Text': 'Chỉ chèn văn bản',
            'Cancel': 'Hủy bỏ',
            'Drop image': 'Kéo thả hình ảnh',
            'or click': 'hoặc nhấp vào',
            'Upload': 'Tải lên',
        }
    },
    uploader: {
        url: `${CONSTANT.BASE_API}media/filemanager/uploads`,
        headers: {
            Authorization: `Bearer ${getAccessToken()}`
        },
        data: { type: 'hospital_content' },
        filesVariableName: () => {
            return 'files'
        }
    }
}
const { Option, OptGroup } = Select;
const ServiceAction = (props) => {
    const { id } = useParams();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    /*================= Editor ============== */

    //define variable
    const [categoriesData, setcategoriesData] = useState([]);
    const [areaData, setAreaData] = useState([]);
    const [countryData, setCountryData] = useState([]);
    const [cityData, setCityData] = useState([]);
    const [districtData, setDistrictData] = useState([]);
    const [workPlace, setWorkPlace] = useState([]);
    /*================= Images ============== */
    const [imageList, setImageList] = useState([]);
    const [previewVisible, setPreviewVisible] = useState(false);
    const [previewTitle, setPreviewTitle] = useState('');
    const [previewImage, setPreviewImage] = useState('');

    const onChangeImages = ({ fileList }) => {
        setImageList(fileList);
    }
    const onTypeChange = e => {
        setWorkPlace(e.target.value);
    };
    const onPreviewImages = async file => {
        let src = file.url;
        if (!src) {
            src = await new Promise(resolve => {
                const reader = new FileReader();
                reader.readAsDataURL(file.originFileObj);
                reader.onload = () => resolve(reader.result);
            });
        }

        setPreviewImage(src);
        setPreviewVisible(true);
        let _previewTitle = file.name || file.url.substring(file.url.lastIndexOf('/') + 1);
        setPreviewTitle(_previewTitle);

    };
    const onRemove = async file => {

        // remove 
    }
    // save image
    const saveImage = async () => {
        let arrImage = [];
        if (imageList.length > 0) {
            for (const item of imageList) {
                if (item.status === 'done') {
                    if (item.response.code === 200 && item.response.data && item.response.data.filename) {
                        let idImage = await axiosInstance.post(`${CONSTANT.API.EXTRA.SAVE_FILE}`, {
                            filename: item.response.data.filename,
                            type: "service_medical"
                        })
                            .then(async res => {

                                if (res && res.data && res.data.code === 200) {
                                    let filename = res.data.data.url;
                                    if (typeof filename !== 'undefined') {
                                        return await axiosInstance.post(`${CONSTANT.API.SERVICE.IMAGE}`, {
                                            filename
                                        })
                                            .then(mRes => {
                                                if (mRes && mRes.data && mRes.data.code === 200) {
                                                    const { data } = mRes.data;
                                                    if (data) {
                                                        return data._id;
                                                    }
                                                }
                                            }
                                            )
                                    }
                                }
                            });
                        arrImage.push(idImage);
                    }
                }
                else {
                    arrImage.push(item.uid);
                }
            }
        }
        return arrImage;
    };

    /*================= Select ============== */
    const onChangeSelect = (type) => async (value) => {
        switch (type) {
            case 'type':
                break;
            case 'area':
                setCountryData([]);
                setCityData([]);
                form.setFieldsValue({
                    country: null,
                    city: null,
                    district: null
                })
                // load country
                await axiosInstance.get(`${CONSTANT.API.DESTINATION.COUNTRY}?perPage=-1&area=${value}`)
                    .then(res => {
                        if (res && res.data && res.data.code === 200) {
                            setCountryData(res.data.data.docs);
                        }
                    });
                break;
            case 'country':
                setCityData([]);
                form.setFieldsValue({
                    city: null,
                    district: null
                })
                // load city
                await axiosInstance.get(`${CONSTANT.API.DESTINATION.CITY}?perPage=-1&country=${value}`)
                    .then(res => {
                        if (res && res.data && res.data.code === 200) {
                            setCityData(res.data.data.docs);
                        }
                    });
                break;
            case 'city':
                setDistrictData([]);
                form.setFieldsValue({
                    district: null
                })
                // load city
                await axiosInstance.get(`${CONSTANT.API.DESTINATION.DISTRICT}?perPage=-1&city=${value}`)
                    .then(res => {
                        if (res && res.data && res.data.code === 200) {
                            setDistrictData(res.data.data.docs);
                        }
                    });
                break;
            default:
                break;
        }
    }

    // submit
    const onFinish = async (values) => {
        setLoading(true);
        let images = await saveImage();
        values.images = images;
        //Action service
        if (!id) {
            await axiosInstance.post(`${CONSTANT.API.SERVICE.SERVICE}`, values)
                .then(res => {
                    if (res && res.data && res.data.code === 200) {
                        message.success('Thêm mới thành công !').then(() => props.history.push('/services'));
                    }
                    else {
                        message.error('Thêm mới thất bại! Vui lòng thử lại sau.');
                    }
                    setLoading(false);
                });
        }
        else {
            await axiosInstance.patch(`${CONSTANT.API.SERVICE.SERVICE}/${id}`, values)
                .then(res => {
                    if (res && res.data && res.data.code === 200) {
                        message.success('Sửa thông tin thành công!')
                            .then(() => props.history.push('/services'))
                    }
                    else {
                        message.error('Sửa thông tin thất bại! Vui lòng thử lại sau.');
                    }
                    setLoading(false);
                });
        }
    };

    // effect
    useEffect(() => {
        // load area
        loadArea();
        // load categorys
        loadCategory();
        //Load service
        if (id && id !== '') {
            loadService();
        }
    }, []);

    // load Area
    const loadArea = async () => {
        await axiosInstance.get(`${CONSTANT.API.DESTINATION.AREA}?perPage=-1&is_parent=true`)
            .then(res => {
                if (res && res.data && res.data.code === 200) {
                    setAreaData(res.data.data.docs);
                }
            });
    }

    // load category
    const loadCategory = async () => {
        await axiosInstance.get(`${CONSTANT.API.SERVICE.CATEGORY}?perPage=-1`)
            .then(res => {
                if (res && res.data && res.data.code === 200) {
                    setcategoriesData(res.data.data.docs);
                }
            });
    }
    const loadService = async () => {
        setLoading(true);
        await axiosInstance.get(`${CONSTANT.API.SERVICE.SERVICE}/${id}`)
            .then(async res => {
                if (res.data.data && res.data.data.area && res.data.data.area._id) {
                    await axiosInstance.get(`${CONSTANT.API.DESTINATION.COUNTRY}?perPage=-1&area=${res.data.data.area._id}`)
                        .then(async res1 => {
                            if (res1 && res1.data && res1.data.code === 200) {
                                await setCountryData(res1.data.data.docs);
                            }

                        });
                }
                // load city by country if exist country
                if (res.data.data && res.data.data.area && res.data.data.country._id) {
                    // load city
                    await axiosInstance.get(`${CONSTANT.API.DESTINATION.CITY}?perPage=-1&country=${res.data.data.country._id}`)
                        .then(async res2 => {
                            if (res2 && res2.data && res2.data.code === 200) {
                                await setCityData(res2.data.data.docs);
                            }
                        });
                }
                // load districts by city if exist country
                if (res.data.data && res.data.data.area && res.data.data.city._id) {
                    // load district
                    await axiosInstance.get(`${CONSTANT.API.DESTINATION.DISTRICT}?perPage=-1&city=${res.data.data.city._id}`)
                        .then(async res3 => {
                            if (res3 && res3.data && res3.data.code === 200) {
                                await setDistrictData(res3.data.data.docs);
                            }
                        });
                }
                if (res && res.data && res.data.code === 200) {
                    const { data } = res.data;
                    form.setFieldsValue({
                        _id: data._id,
                        name: data.name,
                        name_en: data?.translations?.en?.name,
                        time: data.time,
                        area: data.area ? data.area._id : '',
                        country: data.country._id,
                        city: data.city ? data.city._id : '',
                        district: data.district ? data.district._id : '',
                        price: data.price,
                        discount_percent: data.discount_percent,
                        category: data.category ? data.category._id : '',
                        overview: data.overview,
                        what_included: data.what_included,
                        additional_info: data.additional_info,
                        cancellation_policy: data.cancellation_policy,
                        work_place: data?.work_place,
                        address_service: data?.address_service,
                        translations: data?.translations,
                        status: data?.status,
                        is_active: data?.is_active ? 'true' : 'false',
                    });
                    setWorkPlace(data.work_place);
                    if (res.data.data.images && res.data.data.images.length > 0) {
                        let images = [];
                        for (let i = 0; i < res.data.data.images.length; i++) {
                            let image = res.data.data.images[i];
                            if (image) {
                                images = images.concat({
                                    uid: image._id,
                                    name: CONSTANT.STATIC_URL + image.filename,
                                    status: 'done-add',
                                    url: CONSTANT.STATIC_URL + image.filename,
                                    thumbUrl: CONSTANT.STATIC_URL + image.filename
                                });
                            }
                        }
                        setImageList(images);
                    }
                }
            })
            .catch(error => message.warning('Dịch vụ không tồn tại!' + error.message, 2.5).then(() => props.history.push('/services')))
        setLoading(false);
    }
    return (
        <div>
            <Breadcrumb style={{ margin: '16px 0' }}>
                <Breadcrumb.Item >
                    <Link to="/"><HomeOutlined /></Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                    <Link to="/services">Dịch vụ</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                    {id && id !== '' ? 'Sửa thông tin' : 'Thêm mới'}
                </Breadcrumb.Item>
            </Breadcrumb>
            <Layout.Content className="layout-content">
                {
                    loading &&
                    <div style={{ textAlign: 'center' }}>
                        <Spin />
                    </div>
                }

                <Form
                    form={form}
                    layout="vertical"
                    onFinish={onFinish}
                    initialValues={{
                        name: "",
                        time: "",
                        promotion: "",
                        area: null,
                        country: null,
                        city: null,
                        district: null,
                        total_vote: "",
                        price: null,
                        overview: '',
                        what_included: '',
                        additional_info: '',
                        cancellation_policy: '',
                        category: null,
                        images: null,
                        type: "default"
                    }}>
                    <Row gutter={16}>
                        <Col xs={24} sm={24} md={18}>
                            <Tabs defaultActiveKey="vi" type="card" size="large">
                                <Tabs.TabPane tab="Tiếng Việt" key="vi" forceRender={true}>
                                    <Form.Item
                                        label="Tên dịch vụ"
                                        name="name"
                                        required tooltip="Trường bắt buộc nhập"
                                        rules={[
                                            { required: true, message: 'Vui lòng nhập tên dịch vụ!' },
                                        ]}
                                    >
                                        <Input placeholder="Nhập tên dịch vụ" />
                                    </Form.Item>
                                    <Form.Item label="Nơi thực hiện dịch vụ" name="work_place" rules={[
                                        { required: true, message: 'Vui lòng chọn nơi thực hiện!' },
                                    ]}>
                                        <Radio.Group value={workPlace} onChange={onTypeChange}>
                                            <Radio value='at_guest'>Tại nhà khách hàng</Radio>
                                            <Radio value='at_agency'>Tại cơ sở dịch vụ</Radio>
                                            <Radio value='at_both'>Theo tùy chọn khách hàng</Radio>
                                        </Radio.Group>
                                    </Form.Item>
                                    {
                                        workPlace != 'at_guest' &&
                                        <Form.Item
                                            label="Địa chỉ cơ sở"
                                            name="address_service"
                                            required tooltip="Trường bắt buộc nhập, là nơi khách hàng đến để sử dụng dịch vụ !"
                                            rules={[
                                                { required: true, message: 'Vui lòng nhập địa chỉ cơ sở dịch vụ!' },
                                            ]}
                                        >
                                            <Input.TextArea placeholder="Nhập địa chỉ" />
                                        </Form.Item>
                                    }
                                    <Form.Item
                                        name="overview"
                                        label="Tổng quan"
                                        rules={[
                                            { required: true, message: 'Vui lòng nhập mô tả tổng quan về dịch vụ' },
                                        ]}>
                                        <JoditEditor config={configEditor} />
                                    </Form.Item>
                                    <Form.Item
                                        label="Dịch vụ bao gồm"
                                        name="what_included"
                                    >
                                        <JoditEditor config={configEditor} />
                                    </Form.Item>
                                    <Form.Item label="Thông tin khác"
                                        name="additional_info"
                                    >
                                        <JoditEditor config={configEditor} />
                                    </Form.Item>
                                    <Form.Item
                                        label="Chính sách hủy"
                                        name="cancellation_policy"
                                    >
                                        <JoditEditor config={configEditor} />
                                    </Form.Item>
                                </Tabs.TabPane>
                                <Tabs.TabPane forceRender={true} tab="Tiếng Anh" key="en">
                                    <Form.Item
                                        label="Tên dịch vụ"
                                        name={['translations', 'en', 'name']}
                                        required tooltip="Trường bắt buộc nhập"
                                        rules={[
                                            { required: true, message: 'Vui lòng nhập tên dịch vụ!' },
                                        ]}
                                    >
                                        <Input placeholder="Nhập tên dịch vụ" />
                                    </Form.Item>
                                    <Form.Item label="Nơi thực hiện dịch vụ" name="work_place" rules={[
                                        { required: true, message: 'Vui lòng chọn nơi thực hiện!' },
                                    ]}>
                                        <Radio.Group value={workPlace} onChange={onTypeChange}>
                                            <Radio value='at_guest'>Tại nhà khách hàng</Radio>
                                            <Radio value='at_agency'>Tại cơ sở dịch vụ</Radio>
                                            <Radio value='at_both'>Theo tùy chọn khách hàng</Radio>
                                        </Radio.Group>
                                    </Form.Item>
                                    {
                                        workPlace != 'at_guest' &&
                                        <Form.Item
                                            label="Địa chỉ cơ sở"
                                            name={['translations', 'en', 'address_service']}
                                            required tooltip="Trường bắt buộc nhập, là nơi khách hàng đến để sử dụng dịch vụ !"
                                            rules={[
                                                { required: true, message: 'Vui lòng nhập địa chỉ cơ sở dịch vụ!' },
                                            ]}
                                        >
                                            <Input.TextArea placeholder="Nhập địa chỉ" />
                                        </Form.Item>
                                    }
                                    <Form.Item
                                        name={['translations', 'en', 'overview']}
                                        label="Tổng quan"
                                        rules={[
                                            { required: true, message: 'Vui lòng nhập mô tả tổng quan về dịch vụ' },
                                        ]}>
                                        <JoditEditor config={configEditor} />
                                    </Form.Item>
                                    <Form.Item
                                        label="Dịch vụ bao gồm"
                                        name={['translations', 'en', 'what_included']}
                                    >
                                        <JoditEditor config={configEditor} />
                                    </Form.Item>
                                    <Form.Item label="Thông tin khác"
                                        name={['translations', 'en', 'additional_info']}
                                    >
                                        <JoditEditor config={configEditor} />
                                    </Form.Item>
                                    <Form.Item
                                        label="Chính sách hủy"
                                        name={['translations', 'en', 'cancellation_policy']}
                                    >
                                        <JoditEditor config={configEditor} />
                                    </Form.Item>
                                </Tabs.TabPane>
                            </Tabs>
                        </Col>
                        <Col xs={24} sm={24} md={6}>
                            {/* Begin Images */}
                            <Form.Item label="Hình ảnh">
                                <ImgCrop
                                    rotate
                                    modalTitle="Sửa ảnh"
                                    modalOk="Đồng ý"
                                    aspect={800 / 600}
                                    quality={0.8}
                                    modalWidth={800}
                                >
                                    <Upload
                                        listType="picture"
                                        action={`${CONSTANT.API.EXTRA.UPLOAD_IMAGE}`}
                                        fileList={imageList}
                                        onPreview={onPreviewImages}
                                        onChange={onChangeImages}
                                        headers={{
                                            'X-TK': CONSTANT.API.KEY
                                        }}
                                        onRemove={onRemove}
                                    >
                                        {
                                            imageList.length < 15 &&
                                            <Button icon={<UploadOutlined />}>Chọn ảnh tải lên</Button>
                                        }
                                    </Upload>
                                </ImgCrop>
                                <Modal
                                    visible={previewVisible}
                                    title={previewTitle}
                                    footer={null}
                                    onCancel={() => setPreviewVisible(false)}>
                                    <img alt="example" style={{ width: '100%' }} src={previewImage} />
                                </Modal>
                            </Form.Item>
                            {/* End Images */}
                            <Form.Item label="Khu vực"
                                name="area"
                                required tooltip="Khu vực: Châu Á, Châu Âu, Châu Mỹ"
                                rules={[
                                    { required: true, message: 'Vui lòng chọn khu vực!' }
                                ]}>
                                <Select
                                    placeholder="Chọn khu vực"
                                    onChange={onChangeSelect('area')}
                                    style={{ width: '100%' }}>
                                    {
                                        areaData && areaData.length > 0 &&
                                        areaData.map(item => <Select.Option key={item._id}>{item.name}</Select.Option>)
                                    }
                                </Select>
                            </Form.Item>
                            <Form.Item label="Quốc gia"
                                name="country"
                                required tooltip="Trường này bắt buộc chọn"
                                rules={[
                                    { required: true, message: 'Vui lòng chọn quốc gia!' }
                                ]}>
                                <Select
                                    showSearch
                                    placeholder="Chọn quốc gia"
                                    optionFilterProp="children"
                                    onChange={onChangeSelect('country')}
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                    style={{ width: '100%' }}
                                    onFocus={COMMON.offAutoCompleteSelect()}>
                                    {
                                        countryData && countryData.length > 0 &&
                                        countryData.map(item => <Select.Option key={item._id}>{item.name}</Select.Option>)
                                    }
                                </Select>
                            </Form.Item>
                            <Form.Item
                                label="Thành phố"
                                name="city"
                                required tooltip="Trường này bắt buộc chọn"
                                rules={[
                                    { required: true, message: 'Vui lòng chọn thành phố!' }
                                ]}
                            >
                                <Select
                                    showSearch
                                    placeholder="Chọn thành phố"
                                    optionFilterProp="children"
                                    onChange={onChangeSelect('city')}
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                    style={{ width: '100%' }}
                                    onFocus={COMMON.offAutoCompleteSelect()}
                                >
                                    {
                                        cityData && cityData.length > 0 &&
                                        cityData.map(item => <Select.Option key={item._id}>{item.name}</Select.Option>)
                                    }
                                </Select>
                            </Form.Item>
                            <Form.Item
                                label="Quận/huyện"
                                name="district"
                                required tooltip="Trường này bắt buộc chọn"
                                rules={[
                                    { required: true, message: 'Vui lòng chọn quận huyện !' }
                                ]}
                            >
                                <Select
                                    showSearch
                                    placeholder="Chọn quận huyện"
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                    style={{ width: '100%' }}
                                    onFocus={COMMON.offAutoCompleteSelect()}
                                >
                                    {
                                        districtData && districtData.length > 0 &&
                                        districtData.map(item => <Select.Option key={item._id}>{item.name}</Select.Option>)
                                    }
                                </Select>
                            </Form.Item>
                            <Form.Item
                                label="Danh mục"
                                tooltip="Chọn danh mục của dịch vụ"
                                name="category"
                                placeholder="Chọn danh mục của dịch vụ"
                                rules={[
                                    { required: true, message: 'Vui lòng chọn danh mục của dịch vụ !' }
                                ]}
                            >
                                <Select
                                    placeholder="Vui lòng chọn danh mục"
                                    style={{ width: '100%' }}
                                >
                                    {
                                        categoriesData && categoriesData.length > 0 && categoriesData.map(item =>
                                            <OptGroup key={item._id} label={item.name}>
                                                {
                                                    item.childs && item.childs.map(child => <Option key={child._id}>{'   └ ' + child.name}</Option>)
                                                }
                                            </OptGroup>
                                        )
                                    }
                                </Select>
                            </Form.Item>
                            <Form.Item
                                label="Giá"
                                name="price"
                                required tooltip="Trường bắt buộc nhập"
                                rules={[
                                    { required: true, message: 'Vui lòng nhập giá' },
                                ]}

                            >
                                <InputNumber
                                    placeholder="Nhập giá"
                                    formatter={value => `₫ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    parser={value => value.replace('₫', '').replace(/\\s?|(,*)/g, '')}
                                    style={{ width: '100%' }}
                                    min={0} />
                            </Form.Item>
                            <Form.Item
                                label="Phần trăm giảm giá"
                                name="discount_percent"
                                tooltip='Phần trăm giảm giá này áp dụng cho tất cả giá bán của dịch vụ hiện có'
                                required
                                rules={[
                                    { required: true, message: 'Nhập phần trăm giảm giá' },
                                    {
                                        type: 'number', max: 70, message: 'Số tối đa là 70%'
                                    },
                                    {
                                        type: 'number', min: 0, message: 'Số tối thiểu là 0%'
                                    }
                                ]}
                            >
                                <InputNumber placeholder={'Nhập phần trăm giảm giá'}
                                    style={{ width: '100%' }} />
                            </Form.Item>
                            <Form.Item label="Kích hoạt bởi người dùng" name="status">
                                <Select
                                    placeholder="Kích hoạt bởi người dùng"
                                    style={{ width: '100%' }}>
                                    {
                                        userstatus.map(item => <Select.Option key={item.value}>{item.label}</Select.Option>)
                                    }
                                </Select>
                            </Form.Item>
                            <Form.Item label="Trạng thái" name="is_active">
                                <Select
                                    placeholder="Kiểm duyệt"
                                    style={{ width: '100%' }}>
                                    {
                                        status.map(item => <Select.Option key={item.value}>{item.label}</Select.Option>)
                                    }
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>

                    <div className="footer-toolbar">
                        <div className="right">
                            <Button loading={loading} type="primary" icon={<SaveOutlined />}
                                htmlType="submit"
                            >
                                Lưu thông tin
                            </Button>
                        </div>
                    </div>
                </Form>

            </Layout.Content>

        </div>
    )

}

export default ServiceAction;
